import { DatePickerDesignTokens } from '@primeng/themes/types/datepicker';

interface ICustomDatePickerDesignTokens extends DatePickerDesignTokens {
  input: {
    borderColor: string;
  };
  date: DatePickerDesignTokens['date'] & {
    disabled: {
      opacity: string;
    };
  };
  year: DatePickerDesignTokens['year'] & {
    padding: string;
  };
}

export const baseDatepickerToken: ICustomDatePickerDesignTokens = {
  input: {
    borderColor: '{primary.100}',
  },
  panel: {
    borderColor: '{primary.100}',
  },
  header: {
    padding: '0 0 0.25rem 0',
  },
  title: {
    fontWeight: '700',
  },
  selectMonth: {
    hoverBackground: '{neutral.500}',
    color: '{primary.700}',
  },
  selectYear: {
    hoverBackground: '{neutral.500}',
    color: '{primary.700}',
  },
  dayView: {
    margin: '0.25rem 0 0 0',
  },
  weekDay: {
    padding: '0.125rem',
    color: '{primary.700}',
  },
  date: {
    width: '1.75rem',
    height: '1.75rem',
    padding: '0.25rem',
    disabled: {
      opacity: '0.2',
    },
  },
  monthView: {
    margin: '0.25rem 0 0 0',
  },
  month: {
    padding: '0.25rem',
  },
  yearView: {
    margin: '0.25rem 0 0 0',
  },
  year: {
    padding: '0.25rem',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-datepicker-header {
      gap: 1.75rem;
      font-size: 0.875rem !important;
      line-height: 150%;
    }

    .p-datepicker-day-view {
      font-size: 0.875rem !important;
      line-height: 150%;
      font-weight: 600 !important;
    }

    .p-datepicker-panel .p-datepicker-day {
      font-size: 0.875rem !important;
      line-height: 150%;
      font-weight: 500;
    }

    .p-datepicker-panel .p-datepicker-day .p-datepicker-day-selected {
      font-weight: 600;
    }

    .p-datepicker-next-button, .p-datepicker-prev-button, .p-datepicker-select-month, .p-datepicker-select-year {
      background-color: transparent !important;
    }



    .p-datepicker-panel .p-datepicker-day.p-disabled {
      opacity: ${dt('datepicker.date.disabled.opacity')};
    }

    .p-datepicker .p-datepicker-calendar td > span:not(.p-disabled):not(.p-highlight):hover,
    .p-datepicker .p-datepicker-day:not(.p-disabled):not(.p-highlight):hover {
      border-color: ${dt('datepicker.date.hoverBorderColor')} !important;
    }

    .p-inputtext:enabled:focus {
      border-color: ${dt('datepicker.input.borderColor')} !important;
    }
    `,
};
